import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocument = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 18,
	viewBox: "0 0 14 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_9447_26497)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M2.25 0C1.00898 0 0 1.00898 0 2.25V15.75C0 16.991 1.00898 18 2.25 18H11.25C12.491 18 13.5 16.991 13.5 15.75V5.625H9C8.37773 5.625 7.875 5.12227 7.875 4.5V0H2.25ZM9 0V4.5H13.5L9 0ZM2.8125 2.25H5.0625C5.37187 2.25 5.625 2.50312 5.625 2.8125C5.625 3.12188 5.37187 3.375 5.0625 3.375H2.8125C2.50312 3.375 2.25 3.12188 2.25 2.8125C2.25 2.50312 2.50312 2.25 2.8125 2.25ZM2.8125 4.5H5.0625C5.37187 4.5 5.625 4.75313 5.625 5.0625C5.625 5.37187 5.37187 5.625 5.0625 5.625H2.8125C2.50312 5.625 2.25 5.37187 2.25 5.0625C2.25 4.75313 2.50312 4.5 2.8125 4.5ZM3.375 7.875H10.125C10.7473 7.875 11.25 8.37773 11.25 9V11.25C11.25 11.8723 10.7473 12.375 10.125 12.375H3.375C2.75273 12.375 2.25 11.8723 2.25 11.25V9C2.25 8.37773 2.75273 7.875 3.375 7.875ZM3.375 9V11.25H10.125V9H3.375ZM8.4375 14.625H10.6875C10.9969 14.625 11.25 14.8781 11.25 15.1875C11.25 15.4969 10.9969 15.75 10.6875 15.75H8.4375C8.12813 15.75 7.875 15.4969 7.875 15.1875C7.875 14.8781 8.12813 14.625 8.4375 14.625Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_9447_26497",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0 0H13.5V18H0V0Z",
			fill: "white"
		})
	}) })]
});
export default SvgDocument;
